import { type Theme, type Variant } from "types/theme"

export const THEMES = {
  LIGHT: "light",
  DARK: "dark",
} as const

export const VARIANTS = {
  BLUE: "blue",
  GREEN: "green",
  SWAYAM: "swayam",
} as const

export const LS_THEME_KEY = "companion/theme"

export const setWindowTheme = (theme: Theme) => {
  document.documentElement.setAttribute("data-theme", theme)
}

export const setWindowVariant = (variant: Variant) => {
  document.documentElement.setAttribute("data-variant", variant)
}
